import { render } from "./WorktopSettings.vue?vue&type=template&id=ec6a2bba&scoped=true"
import script from "./WorktopSettings.vue?vue&type=script&lang=js"
export * from "./WorktopSettings.vue?vue&type=script&lang=js"

import "./WorktopSettings.vue?vue&type=style&index=0&id=ec6a2bba&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6a2bba"]])

export default __exports__